export default "__VITE_ASSET__l4V7LYwg__"